module.exports = __webpack_public_path__ + "img/crock-pot-beef-roast-and-veggies.09b707f1.jpg";